import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";

import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import axios from "axios";
import Loader from "../Loader/Loader";
import DataTable from "./components/DataTable";
import { Typography, Drawer } from "@material-ui/core";
import PassengerCard from "./components/passengerCard";
import TripType from "./components/tripType";
import JourneyClass from "./components/journeyClass";
import OriginDestination from "./components/OriginDestination";
import JourneyDate from "./components/journeyDate";
import flightBanner from "../../assets/img/flight-banner.png";
import IconSearch from "@material-ui/icons/Search";
import IconBack from "@material-ui/icons/ArrowBack";
import PopularDestinations from "./PopularDestinations";
import "./index.css";
import { momentToHrs } from "../../helpers/date.helper";
import { addToHistory } from "./utils/SearchHistory";
import RecentSearches from "./components/RecentSearches";
import FlyDuration from "./components/filters/FlyDuration";
import SortBy from "./components/filters/SortBy";
import SelectedCabins from "./components/filters/SelectedCabins";
import PriceRange from "./components/filters/PriceRange.js";
import DepartureTimeRange from "./components/filters/TimeRange";
import ArrivalTimeRange from "./components/filters/TimeRange";
import Baggages from "./components/filters/Baggages";
import MaxStops from "./components/filters/MaxStops";
import moment from "moment";
import CurrencySelector from "./CurrencySelector";
import Footer from "./components/footer";
import Calendar from "./components/Calendar";
import PriceGraph from "./components/PriceGraph";
import FlightProviders from "./utils/FlightProviders";

/////////////////////////////////////////////////////////

import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import FlightSearchV2 from "./FlightSearch/FlightSearchV2";

//////////////////////////////////////////////////

import { getVendorDetails } from "../../store/actions/vendor/Vendor";
import { getCommission } from "../../store/actions/admin/Admin";
import banner from "../../assets/img/bannerimage.png";
import Typed from "typed.js";

const SESSION_KEY = "SESSION_KEY";
const PRICE_RANGES = {
  USD: [0, 5000],
  AUD: [0, 10000],
  INR: [0, 100000],
};

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  drawer: {
    background: "red",
  },
  control: {
    padding: "4%",
    [theme.breakpoints.down("sm")]: {
      padding: "4%",
    },
  },
  main: {
    paddingTop: "30%",
    // backgroundColor: "var(--darker)",
    // [theme.breakpoints.down("sm")]: {
    //   paddingTop: "18%",
    // },
  },

  main2: {
    paddingTop: "8%",

    // backgroundColor: "var(--darker)",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "2%",
      paddingRight: "2%",
      paddingTop: "21%",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "2%",
      paddingRight: "2%",
      paddingTop: "14%",
    },
  },
  container: {
    backgroundColor: "var(--white)",
    borderRadius: 5,
  },
  formSelect: {
    fontSize: ".875rem",
    padding: "0.5%",
  },
  flightBG: {
    height: "385px",
    [theme.breakpoints.down("sm")]: {
      backgroundImage: `url('${flightBanner}')`,
      height: "232px",
      marginTop: "62px",
      marginBottom: "0px",
    },
    background: `url('${flightBanner}') no-repeat`,
    backgroundSize: "100% 100%",
  },
}));

const DateStringToDate = (d) => {
  let date = new Date(d);
  return date;
};

const JOURNEY_TYPES = ["One Way", "Return"];

function createUTCdateForISO(dateString) {
  if (dateString == null || dateString == undefined) return null;
  const offset = new Date().getTimezoneOffset();
  const myDate = Date.parse(dateString) + offset * 60 * 1000;
  const dateAsISO = new Date(myDate).toISOString();
  return dateAsISO;
}

function Airports(props) {
  const classes = useStyles();
  const search = useLocation().search;
  const searchParam = new URLSearchParams(search);
  const [selectedDepartureDate, setSelectedDepartureDate] = React.useState(
    searchParam.get("selectedDepartureDate")
  );
  const [journeyType, setJourneyType] = React.useState(
    searchParam.get("journeyType") ? searchParam.get("journeyType") : "One Way"
  );
  const [selectedArrivalDate, setSelectedArrivalDate] = React.useState(
    searchParam.get("selectedArrivalDate")
  );
  const [departureAirport, setDepartureAirport] = React.useState(
    searchParam.get("departureAirport")
  );
  const [departureAirportName, setDepartureAirportName] = React.useState(
    searchParam.get("departureAirportName")
  );
  const [arrivalAirport, setArrivalAirport] = React.useState(
    searchParam.get("arrivalAirport")
  );
  const [arrivalAirportName, setArrivalAirportName] = React.useState(
    searchParam.get("arrivalAirportName")
  );
  const [adults, setAdults] = React.useState(
    searchParam.get("adults") ? Number(searchParam.get("adults")) : 1
  );
  const [kids, setKids] = React.useState(
    searchParam.get("kids") ? Number(searchParam.get("kids")) : 0
  );
  const [infants, setInfants] = React.useState(
    searchParam.get("infants") ? Number(searchParam.get("infants")) : 0
  );
  const [flightClass, setFlightClass] = React.useState(
    searchParam.get("flightClass") ? searchParam.get("flightClass") : "Any"
  );
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("price");

  /////////////////////////FILTERS////////////////////////////////

  const [flyDuration, setFlyDuration] = useState(1);
  const [useflyDuration, setUseFlyDuration] = useState(false);
  const [useSortBy, setUseSortBy] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [usePriceRange, setUsePriceRange] = useState(false);
  const [arrivalTimeRange, setArrivalTimeRange] = useState({
    min: new Date(),
    max: new Date(),
  });
  const [useArrivalTimeRange, setUseArrivalTimeRange] = useState(false);
  const [baggage, setBaggage] = useState({
    hand_bag: "0",
    hold_bag: "0",
  });
  const [useBaggage, setUseBaggage] = useState(false);
  const [departureTimeRange, setDepartureTimeRange] = useState({
    min: new Date(),
    max: new Date(),
  });
  const [useDepartureTimeRange, setUseDepartureTimeRange] = useState(false);
  const [stops, setStops] = useState("-1");
  const [useStops, setUseStops] = useState(false);
  const [sessionLoaded, setSessionLoaded] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [page, setPage] = useState(props.page || 2);
  const [searchQuery, setSearchQuery] = useState("");

  //////////////////////FILTERS END///////////////////////////////

  const typedRef = useRef(null);

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: [
        "Book Cheap Flights, Which You Can't Find Anywhere",
        "Find the Best Flight Deals",
        "Compare Prices from Multiple Airlines",
        "Book Your Dream Vacation",
      ],
      typeSpeed: 40,
      backSpeed: 30,
      backDelay: 1500,
      startDelay: 500,
      loop: true,
      showCursor: true,
      cursorChar: "✈",
      autoInsertCss: true,
      fadeOut: true,
      fadeOutClass: "typed-fade-out",
      fadeOutDelay: 500,
      onStringTyped: (arrayPos) => {
        // Optional: Add any additional effects when a string is typed
      },
    });

    return () => {
      typed.destroy();
    };
  }, []);

  useEffect(() => {
    try {
      let sessionData = sessionStorage.getItem(SESSION_KEY);
      if (sessionData) {
        sessionData = JSON.parse(sessionData);
        setDepartureAirport(sessionData["departureAirport"]);
        setDepartureAirportName(sessionData["departureAirportName"]);
        setSelectedDepartureDate(moment(sessionData["selectedDepartureDate"]));
        setArrivalAirport(sessionData["arrivalAirport"]);
        setArrivalAirportName(sessionData["arrivalAirportName"]);
        setAdults(sessionData["adults"]);
        setKids(sessionData["kids"]);
        setInfants(sessionData["infants"]);
        setSortBy(sessionData["sortBy"]);
        setStops(sessionData["stops"]);
        setFlightClass(sessionData["flightClass"]);
        setSelectedArrivalDate(moment(sessionData["selectedArrivalDate"]));
        setFlyDuration(sessionData["flyDuration"]);
        setPriceRange(sessionData["priceRange"]);
        setBaggage(sessionData["baggage"]);
        setDepartureTimeRange(sessionData["departureTimeRange"]);
        setArrivalTimeRange(sessionData["arrivalTimeRange"]);
        setSessionLoaded(true);
      }
    } catch (err) {
      console.log(err);
    }

    props.dispatch(getCommission());

    let loginType = localStorage.getItem("userLoginType");
    if (loginType == "vendor" && props.commissionType == "") {
      props.dispatch(getVendorDetails());
    }
  }, []);

  useEffect(() => {
    if (sessionLoaded) {
      // searchFlights();
      setSessionLoaded(false);
    }
  }, [sessionLoaded]);

  useEffect(() => {
    searchFlights();
  }, []);

  useEffect(() => {
    // searchFlights();
  }, [
    props.currency,
    flyDuration,
    flightClass,
    priceRange,
    arrivalTimeRange,
    departureTimeRange,
    stops,
    baggage,
  ]);

  useEffect(() => {
    if (!departureAirport || !arrivalAirport) {
      return;
    }
    if (journeyType === "Return") {
      if (!selectedArrivalDate) return;
      if (moment(selectedArrivalDate).isBefore(moment(selectedDepartureDate))) {
        setSelectedDepartureDate(selectedArrivalDate);
      }
    }

    let priceSearchQuery = `flights/airlines-offer?fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}`;

    let currency = props.currency;

    if (currency) priceSearchQuery += `&currency=${currency}`;

    if (flightClass && flightClass !== "Any") {
      priceSearchQuery += `&selected_cabins=${flightClass}`;
    }
    setSearchQuery(priceSearchQuery);
  }, [
    flightClass,
    journeyType,
    arrivalAirport,
    departureAirport,
    selectedArrivalDate,
    selectedDepartureDate,
    kids,
    infants,
    adults,
  ]);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerOpen(open);
  };

  const searchFlights = async function () {
    if (props.onFlightSearch)
      return props.onFlightSearch.call({
        departureAirport,
        arrivalAirport,
        selectedDepartureDate,
        journeyType,
        selectedArrivalDate,
        setDrawerOpen,
        departureAirportName,
        arrivalAirportName,
        adults,
        kids,
        infants,
        flightClass,
        setLoading,
        sortBy,
        useStops,
        stops,
        useflyDuration,
        flyDuration,
        usePriceRange,
        priceRange,
        useDepartureTimeRange,
        departureTimeRange,
        useArrivalTimeRange,
        arrivalTimeRange,
        useBaggage,
        baggage,
      });
    setFlights([]);

    const sessionData = {};
    if (!departureAirport || !arrivalAirport || !selectedDepartureDate) {
      return;
    }
    if (journeyType === "Return" && !selectedArrivalDate) {
      return;
    }

    setDrawerOpen(false);
    let RecentSearches = addToHistory({
      start: { code: departureAirport, name: departureAirportName },
      end: { code: arrivalAirport, name: arrivalAirportName },
      journey_type: journeyType,
      arrivalDate: selectedArrivalDate,
      departureDate: selectedDepartureDate,
      adults: adults,
      kids: kids,
      infants: infants,
      flightClass: flightClass,
    });

    const { dispatch } = props;
    dispatch({ type: "SET_SEARCH_HISTORY", data: RecentSearches });
    setLoading(true);

    let normalQueryParam = `flights/airlines-offer?fly_from=${departureAirport}&date_from=${moment(
      selectedDepartureDate
    ).format(
      "DD/MM/yyyy"
    )}&fly_to=${arrivalAirport}&limit=250&adults=${adults}&children=${kids}&infants=${infants}`;
    const airiqQueryParam = `flights/offers-airiq?date_from=${moment(
      selectedDepartureDate
    ).format(
      "yyyy/MM/DD"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}`;
    const tboQueryParam = `flights/offers-tbo?date_from=${moment(
      selectedDepartureDate
    ).format(
      "yyyy-MM-DD"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}${
      journeyType === "Return" && selectedArrivalDate
        ? `&date_to=${moment(selectedArrivalDate).format("yyyy-MM-DD")}`
        : ""
    }`;

    sessionData["departureAirport"] = departureAirport;
    sessionData["departureAirportName"] = departureAirportName;
    sessionData["selectedDepartureDate"] = selectedDepartureDate;
    sessionData["arrivalAirport"] = arrivalAirport;
    sessionData["arrivalAirportName"] = arrivalAirportName;
    sessionData["adults"] = adults;
    sessionData["kids"] = kids;
    sessionData["infants"] = infants;

    if (sortBy) {
      normalQueryParam += `&sort=${sortBy}`;
      sessionData["sortBy"] = sortBy;
    }
    // if (selectedCurrency) {
    //   queryParam += `&currency=${selectedCurrency}`
    //   priceSearchQuery+= `&currency=${selectedCurrency}`
    // }
    let currency = props.currency;
    if (!currency) {
      currency = localStorage.getItem("selectedCurrency");
    }
    if (currency) normalQueryParam += `&currency=${currency}`;

    if (useStops && stops != -1 && stops != 2) {
      normalQueryParam += `&max_stopovers=${stops}`;
      sessionData["stops"] = stops;
    }
    if (flightClass && flightClass !== "Any") {
      normalQueryParam += `&selected_cabins=${flightClass}`;
      sessionData["flightClass"] = flightClass;
    }

    if (journeyType === "Return" && selectedArrivalDate) {
      normalQueryParam += `&return_from=${moment(selectedArrivalDate).format(
        "DD/MM/yyyy"
      )}`;
      sessionData["selectedArrivalDate"] = selectedArrivalDate;
    }

    if (useflyDuration && flyDuration != 0) {
      normalQueryParam += `&max_fly_duration=${flyDuration}`;
      sessionData["flyDuration"] = flyDuration;
    }
    if (
      usePriceRange &&
      priceRange &&
      priceRange[0] >= 0 &&
      priceRange[1] != 0
    ) {
      normalQueryParam += `&price_from=${priceRange[0]}&price_to=${priceRange[1]}`;
      // sessionData["priceRange"] = priceRange;
    }
    if (
      useDepartureTimeRange &&
      departureTimeRange &&
      departureTimeRange.min != "" &&
      departureTimeRange.max != ""
    ) {
      normalQueryParam += `&dtime_from=${momentToHrs(
        departureTimeRange.min
      )}&dtime_from=${momentToHrs(departureTimeRange.max)}`;
      sessionData["departureTimeRange"] = departureTimeRange;
    }

    if (
      useArrivalTimeRange &&
      arrivalTimeRange &&
      arrivalTimeRange.min != "" &&
      arrivalTimeRange.max != ""
    ) {
      normalQueryParam += `&atime_from=${momentToHrs(
        arrivalTimeRange.min
      )}&atime_from=${momentToHrs(arrivalTimeRange.max)}`;
      sessionData["arrivalTimeRange"] = arrivalTimeRange;
    }
    if (useBaggage && baggage) {
      if (baggage.hand_bag != "0") {
        normalQueryParam += `&adult_hand_bag=${baggage.hand_bag}`;
      }

      if (baggage.hold_bag != "0") {
        normalQueryParam += `&adult_hold_bag=${baggage.hold_bag}`;
      }
      sessionData["baggage"] = baggage;
    }
    const [
      normalFlightResponse,
      airiqFlightResponse,
      tboFlightResponse,
    ] = await Promise.allSettled([
      axios.get(normalQueryParam),
      axios.get(airiqQueryParam),
      axios.get(tboQueryParam),
    ]);

    if (
      normalFlightResponse.status === "fulfilled" &&
      normalFlightResponse.value.data &&
      normalFlightResponse.value.data.data
    ) {
      let data = normalFlightResponse.value.data.data.data || [];
      data &&
        data.map((d) => {
          let slices = [];
          if (journeyType !== "Return") {
            let slice = {
              origin: departureAirport,
              destination: arrivalAirport,
              duration: d.duration.departure,
              airline: {},
            };
            let segments = [];
            d.route.map((route) => {
              segments.push(route);
              slice.airline[route.airline] = 1;
            });
            slice.segments = segments;
            slices.push(slice);
          } else {
            let segments = [];
            let slice = {
              origin: departureAirport,
              destination: arrivalAirport,
              duration: d.duration.departure,
              airline: {},
            };
            d.route.map((route) => {
              segments.push(route);
              slice.airline[route.airline] = 1;
              if (route.flyTo === arrivalAirport) {
                slice.segments = [...segments];
                slices.push({ ...slice });
                segments = [];
                slice = {
                  destination: departureAirport,
                  origin: arrivalAirport,
                  duration: d.duration.return,
                  airline: {},
                };
              }
            });
            slice.segments = [...segments];
            slices.push({ ...slice });
          }
          d.slices = slices;
          d.provider = FlightProviders.KIWI;
          return d;
        });

      setFlights((prev) =>
        [...prev, ...data].sort((a, b) => a.price - b.price)
      );
    }

    if (
      !(journeyType === "Return" && selectedArrivalDate) &&
      airiqFlightResponse.status === "fulfilled" &&
      airiqFlightResponse.value.data
    ) {
      const { data = [] } = airiqFlightResponse.value.data;
      const flightsData = data.map((d) => {
        const slices = [
          {
            duration:
              (new Date(`${d.arival_date} ${d.arival_time}`) -
                new Date(`${d.departure_date} ${d.departure_time}`)) /
              1000,
            airline: { [d.flight_number.split(" ")[0]]: 1 },
            segments: [
              {
                flyFrom: d.origin,
                flyTo: d.destination,
                flight_number: d.flight_number.split(" ")[1],
                fare_category: "M",
                operating_carrier: d.flight_number.split(" ")[0],
                airline: d.flight_number.split(" ")[0],
                local_departure: `${d.departure_date} ${d.departure_time}:00.000Z`,
                utc_departure: createUTCdateForISO(
                  `${d.departure_date} ${d.departure_time}`
                ),
                local_arrival: `${d.arival_date} ${d.arival_time}:00.000Z`,
                utc_arrival: createUTCdateForISO(
                  `${d.arival_date} ${d.arival_time}`
                ),
              },
            ],
          },
        ];
        return {
          ticked_id: d.ticket_id,
          flight_id: d.flight_number.replace(" ", "-"),
          slices,
          price: d.price,
          provider: FlightProviders.AIRIQ,
        };
      });

      setFlights((prev) =>
        [...prev, ...flightsData].sort((a, b) => a.price - b.price)
      );
    }

    if (
      tboFlightResponse.status === "fulfilled" &&
      tboFlightResponse.value.data
    ) {
      const { data = [], traceId } = tboFlightResponse.value.data;

      try {
        // Process TBO flights based on journey type
        if (journeyType === "Return" && data.length >= 2) {
          // For return journeys, process both outbound and return flights
          const outboundFlights = data[0] || [];
          const returnFlights = data[1] || [];

          // Create combinations of outbound and return flights
          const combinedFlights = [];

          // Limit the number of combinations to avoid performance issues
          const maxOutbound = Math.min(outboundFlights.length, 20);
          const maxReturn = Math.min(returnFlights.length, 20);

          for (let i = 0; i < maxOutbound; i++) {
            const outboundFlight = outboundFlights[i];

            if (
              !outboundFlight?.Segments ||
              !Array.isArray(outboundFlight.Segments) ||
              outboundFlight.Segments.length === 0
            ) {
              continue;
            }

            // Get outbound segments
            const outboundSegmentsArray = outboundFlight.Segments[0];
            if (
              !Array.isArray(outboundSegmentsArray) ||
              outboundSegmentsArray.length === 0
            ) {
              continue;
            }

            // Map outbound segments
            const outboundMappedSegments = outboundSegmentsArray
              .map((segment) => {
                if (
                  !segment?.Origin?.Airport?.AirportCode ||
                  !segment?.Destination?.Airport?.AirportCode ||
                  !segment?.Airline
                ) {
                  return null;
                }

                return {
                  flyFrom: segment.Origin.Airport.AirportCode,
                  flyTo: segment.Destination.Airport.AirportCode,
                  flight_no: segment.Airline.FlightNumber,
                  fare_category: segment.Airline.FareClass || "ECONOMY",
                  operating_carrier: segment.Airline.AirlineCode,
                  airline:
                    segment.Airline.AirlineName || segment.Airline.AirlineCode,
                  local_departure: segment.Origin.DepTime,
                  utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                  local_arrival: segment.Destination.ArrTime,
                  utc_arrival: createUTCdateForISO(segment.Destination.ArrTime),
                };
              })
              .filter(Boolean);

            if (outboundMappedSegments.length === 0) {
              continue;
            }

            // Calculate outbound duration
            const outboundFirstSegment = outboundSegmentsArray[0];
            const outboundLastSegment =
              outboundSegmentsArray[outboundSegmentsArray.length - 1];
            const outboundDuration =
              (new Date(outboundLastSegment.Destination.ArrTime) -
                new Date(outboundFirstSegment.Origin.DepTime)) /
              1000;

            for (let j = 0; j < maxReturn; j++) {
              const returnFlight = returnFlights[j];

              if (
                !returnFlight?.Segments ||
                !Array.isArray(returnFlight.Segments) ||
                returnFlight.Segments.length === 0
              ) {
                continue;
              }

              // Get return segments
              const returnSegmentsArray = returnFlight.Segments[0];
              if (
                !Array.isArray(returnSegmentsArray) ||
                returnSegmentsArray.length === 0
              ) {
                continue;
              }

              // Map return segments
              const returnMappedSegments = returnSegmentsArray
                .map((segment) => {
                  if (
                    !segment?.Origin?.Airport?.AirportCode ||
                    !segment?.Destination?.Airport?.AirportCode ||
                    !segment?.Airline
                  ) {
                    return null;
                  }

                  return {
                    flyFrom: segment.Origin.Airport.AirportCode,
                    flyTo: segment.Destination.Airport.AirportCode,
                    flight_no: segment.Airline.FlightNumber,
                    fare_category: segment.Airline.FareClass || "ECONOMY",
                    operating_carrier: segment.Airline.AirlineCode,
                    airline:
                      segment.Airline.AirlineName ||
                      segment.Airline.AirlineCode,
                    local_departure: segment.Origin.DepTime,
                    utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                    local_arrival: segment.Destination.ArrTime,
                    utc_arrival: createUTCdateForISO(
                      segment.Destination.ArrTime
                    ),
                  };
                })
                .filter(Boolean);

              if (returnMappedSegments.length === 0) {
                continue;
              }

              // Calculate return duration
              const returnFirstSegment = returnSegmentsArray[0];
              const returnLastSegment =
                returnSegmentsArray[returnSegmentsArray.length - 1];
              const returnDuration =
                (new Date(returnLastSegment.Destination.ArrTime) -
                  new Date(returnFirstSegment.Origin.DepTime)) /
                1000;

              // Create slices for both outbound and return
              const slices = [
                {
                  origin: departureAirport,
                  destination: arrivalAirport,
                  duration: outboundDuration,
                  airline: { [outboundFirstSegment.Airline.AirlineCode]: 1 },
                  segments: outboundMappedSegments,
                },
                {
                  origin: arrivalAirport,
                  destination: departureAirport,
                  duration: returnDuration,
                  airline: { [returnFirstSegment.Airline.AirlineCode]: 1 },
                  segments: returnMappedSegments,
                },
              ];

              // Create combined flight
              combinedFlights.push({
                ticked_id: `${outboundFlight.Source}-${returnFlight.Source}`,
                flight_id: `${outboundFirstSegment.Airline.FlightNumber}-${returnFirstSegment.Airline.FlightNumber}`,
                slices,
                price:
                  outboundFlight.Fare.OfferedFare +
                  returnFlight.Fare.OfferedFare,
                baglimit: {
                  hand_weight: outboundFirstSegment.CabinBaggage || "0 KG",
                  hold_weight: outboundFirstSegment.Baggage || "0 KG",
                },
                provider: FlightProviders.TBO,
                ResultIndex: [
                  "" + outboundFlight.ResultIndex,
                  "" + returnFlight.ResultIndex,
                ],
                TraceId: traceId,
                IsRefundable:
                  outboundFlight.IsRefundable && returnFlight.IsRefundable,
              });
            }
          }

          if (combinedFlights.length > 0) {
            console.log(
              "Successfully processed TBO return flights:",
              combinedFlights.length
            );
            console.log("combinedFlights munna", combinedFlights);
            setFlights((prev) =>
              [...prev, ...combinedFlights].sort((a, b) => a.price - b.price)
            );
          }
        } else if (journeyType === "Return" && data.length >= 1) {
          // Process single array data for return journeys
          console.log("Processing return journey with single data array");

          const outboundFlights = data[0] || [];
          const singleArrayReturnFlights = [];
          const maxFlights = Math.min(outboundFlights.length, 40);

          for (let i = 0; i < maxFlights; i++) {
            const flight = outboundFlights[i];

            if (
              !flight?.Segments ||
              !Array.isArray(flight.Segments) ||
              flight.Segments.length < 2
            ) {
              continue;
            }

            const outboundSegmentsArray = flight.Segments[0];
            const returnSegmentsArray = flight.Segments[1];

            if (
              !Array.isArray(outboundSegmentsArray) ||
              outboundSegmentsArray.length === 0 ||
              !Array.isArray(returnSegmentsArray) ||
              returnSegmentsArray.length === 0
            ) {
              continue;
            }

            const outboundMappedSegments = outboundSegmentsArray
              .map((segment) => {
                if (
                  !segment?.Origin?.Airport?.AirportCode ||
                  !segment?.Destination?.Airport?.AirportCode ||
                  !segment?.Airline
                ) {
                  return null;
                }

                return {
                  flyFrom: segment.Origin.Airport.AirportCode,
                  flyTo: segment.Destination.Airport.AirportCode,
                  flight_no: segment.Airline.FlightNumber,
                  fare_category: segment.Airline.FareClass || "ECONOMY",
                  operating_carrier: segment.Airline.AirlineCode,
                  airline:
                    segment.Airline.AirlineName || segment.Airline.AirlineCode,
                  local_departure: segment.Origin.DepTime,
                  utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                  local_arrival: segment.Destination.ArrTime,
                  utc_arrival: createUTCdateForISO(segment.Destination.ArrTime),
                };
              })
              .filter(Boolean);

            if (outboundMappedSegments.length === 0) {
              continue;
            }

            const returnMappedSegments = returnSegmentsArray
              .map((segment) => {
                if (
                  !segment?.Origin?.Airport?.AirportCode ||
                  !segment?.Destination?.Airport?.AirportCode ||
                  !segment?.Airline
                ) {
                  return null;
                }

                return {
                  flyFrom: segment.Origin.Airport.AirportCode,
                  flyTo: segment.Destination.Airport.AirportCode,
                  flight_no: segment.Airline.FlightNumber,
                  fare_category: segment.Airline.FareClass || "ECONOMY",
                  operating_carrier: segment.Airline.AirlineCode,
                  airline:
                    segment.Airline.AirlineName || segment.Airline.AirlineCode,
                  local_departure: segment.Origin.DepTime,
                  utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                  local_arrival: segment.Destination.ArrTime,
                  utc_arrival: createUTCdateForISO(segment.Destination.ArrTime),
                };
              })
              .filter(Boolean);

            if (returnMappedSegments.length === 0) {
              continue;
            }

            const outboundFirstSegment = outboundSegmentsArray[0];
            const outboundLastSegment =
              outboundSegmentsArray[outboundSegmentsArray.length - 1];
            const outboundDuration =
              (new Date(outboundLastSegment.Destination.ArrTime) -
                new Date(outboundFirstSegment.Origin.DepTime)) /
              1000;

            const returnFirstSegment = returnSegmentsArray[0];
            const returnLastSegment =
              returnSegmentsArray[returnSegmentsArray.length - 1];
            const returnDuration =
              (new Date(returnLastSegment.Destination.ArrTime) -
                new Date(returnFirstSegment.Origin.DepTime)) /
              1000;

            const slices = [
              {
                origin: departureAirport,
                destination: arrivalAirport,
                duration: outboundDuration,
                airline: { [outboundFirstSegment.Airline.AirlineCode]: 1 },
                segments: outboundMappedSegments,
              },
              {
                origin: arrivalAirport,
                destination: departureAirport,
                duration: returnDuration,
                airline: { [returnFirstSegment.Airline.AirlineCode]: 1 },
                segments: returnMappedSegments,
              },
            ];

            singleArrayReturnFlights.push({
              ticked_id: flight.Source,
              flight_id: `${outboundFirstSegment.Airline.FlightNumber}-${returnFirstSegment.Airline.FlightNumber}`,
              slices,
              price: flight.Fare.OfferedFare,
              baglimit: {
                hand_weight: outboundFirstSegment.CabinBaggage || "0 KG",
                hold_weight: outboundFirstSegment.Baggage || "0 KG",
              },
              provider: FlightProviders.TBO,
              ResultIndex: flight.ResultIndex,
              TraceId: traceId,
              IsRefundable: flight.IsRefundable,
            });
          }

          if (singleArrayReturnFlights.length > 0) {
            console.log(
              "Successfully processed TBO single array return flights:",
              singleArrayReturnFlights.length
            );
            setFlights((prev) =>
              [...prev, ...singleArrayReturnFlights].sort(
                (a, b) => a.price - b.price
              )
            );
          }
        } else {
          // For one-way journeys, process only outbound flights
          const flightsData = data[0]
            ?.map((flight) => {
              if (
                !flight?.Segments ||
                !Array.isArray(flight.Segments) ||
                flight.Segments.length === 0
              ) {
                console.warn("Invalid flight data:", flight);
                return null;
              }

              // Get the segments array (flight.Segments[0] is the array of segments)
              const segmentsArray = flight.Segments[0];
              if (!Array.isArray(segmentsArray) || segmentsArray.length === 0) {
                console.warn("Invalid segments array:", flight.Segments);
                return null;
              }

              // Map all segments
              const mappedSegments = segmentsArray
                .map((segment) => {
                  if (
                    !segment?.Origin?.Airport?.AirportCode ||
                    !segment?.Destination?.Airport?.AirportCode ||
                    !segment?.Airline
                  ) {
                    console.warn("Invalid segment data:", segment);
                    return null;
                  }

                  return {
                    flyFrom: segment.Origin.Airport.AirportCode,
                    flyTo: segment.Destination.Airport.AirportCode,
                    flight_no: segment.Airline.FlightNumber,
                    fare_category: segment.Airline.FareClass || "ECONOMY",
                    operating_carrier: segment.Airline.AirlineCode,
                    airline:
                      segment.Airline.AirlineName ||
                      segment.Airline.AirlineCode,
                    local_departure: segment.Origin.DepTime,
                    utc_departure: createUTCdateForISO(segment.Origin.DepTime),
                    local_arrival: segment.Destination.ArrTime,
                    utc_arrival: createUTCdateForISO(
                      segment.Destination.ArrTime
                    ),
                  };
                })
                .filter(Boolean);

              if (mappedSegments.length === 0) {
                console.warn("No valid segments found for flight:", flight);
                return null;
              }

              // Calculate total duration using first and last segment
              const firstSegment = segmentsArray[0];
              const lastSegment = segmentsArray[segmentsArray.length - 1];
              const totalDuration =
                (new Date(lastSegment.Destination.ArrTime) -
                  new Date(firstSegment.Origin.DepTime)) /
                1000;

              const slices = [
                {
                  origin: departureAirport,
                  destination: arrivalAirport,
                  duration: totalDuration,
                  airline: { [firstSegment.Airline.AirlineCode]: 1 },
                  segments: mappedSegments,
                },
              ];

              return {
                ticked_id: flight.Source,
                flight_id: firstSegment.Airline.FlightNumber,
                slices,
                price: flight.Fare.OfferedFare,
                baglimit: {
                  hand_weight: firstSegment.CabinBaggage || "0 KG",
                  hold_weight: firstSegment.Baggage || "0 KG",
                },
                provider: FlightProviders.TBO,
                ResultIndex: flight.ResultIndex,
                TraceId: traceId,
                IsRefundable: flight.IsRefundable,
              };
            })
            .filter(Boolean);

          if (flightsData && flightsData.length > 0) {
            console.log(
              "Successfully processed TBO flights:",
              flightsData.length
            );
            setFlights((prev) =>
              [...prev, ...flightsData].sort((a, b) => a.price - b.price)
            );
          }
        }
      } catch (error) {
        console.error("Error processing TBO flights:", error);
      }
    }

    setPage(2);

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));

    setLoading(false);
  };

  useEffect(() => {
    if (!loading) {
      if (page == 1)
        setTimeout(() => {
          window.scrollTo({ top: 250, behavior: "smooth" });
        }, 0);
    }
  }, [loading]);

  const handleFlightSelect = (flight) => {
    const { dispatch } = props;
    dispatch({ type: "SELECTED_FLIGHT", flight });
    console.log(
      "selected flight|outside flightresults||" + JSON.stringify(flight)
    );
    props.history.push(
      `/flights-book/v${
        flight.provider === FlightProviders.AIRIQ ? "book4" : flight.provider
      }/${partialRoute(
        flight
      )}?journeyType=${journeyType}&departureAirport=${departureAirport}&arrivalAirport=${arrivalAirport}&departureDate=${selectedDepartureDate}&arrivalDate=${selectedArrivalDate}&adults=${adults}&kids=${kids}&infants=${infants}&flightClass=${flightClass}`
    );
  };

  const partialRoute = (flight) => {
    if (flight.provider === FlightProviders.KIWI) return flight.booking_token;
    if (flight.provider === FlightProviders.AIRIQ) return flight.ticked_id;
    if (flight.provider === FlightProviders.TBO)
      return flight.flight_id + "-" + flight.ticked_id;
    return flight.flight_id;
  };
  const onRecentSearchSelect = (item) => {
    if (!item) return;
    if (item.start) {
      setDepartureAirport(item.start.code);
      setDepartureAirportName(item.start.name);
    }
    if (item.end) {
      setArrivalAirport(item.end.code);
      setArrivalAirportName(item.end.name);
    }
    if (item.journey_type) {
      setJourneyType(item.journey_type);
      if (item.journey_type == "Return") {
        let momDepDate = moment(item.departureDate);
        if (momDepDate.isSameOrAfter(moment()))
          setSelectedDepartureDate(momDepDate);

        let momArrDate = moment(item.arrivalDate);
        if (momArrDate.isSameOrAfter(moment()))
          setSelectedArrivalDate(momArrDate);
      } else if (item.journey_type == "One Way") {
        let momDepDate = moment(item.departureDate);
        if (momDepDate.isSameOrAfter(moment()))
          setSelectedDepartureDate(momDepDate);
      }
    }
  };

  const handlePopularDestinationSelect = (item) => {
    if (!item) return;
    if (item.start) {
      setDepartureAirportName(item.start.name);
      setDepartureAirport(item.start.code);
    }
    if (item.end) {
      setArrivalAirportName(item.end.name);
      setArrivalAirport(item.end.code);
    }
    if (page == 1) window.scrollTo({ top: 250, behavior: "smooth" });
    else if (page == 2) window.scrollTo({ top: 10, behavior: "smooth" });
  };

  const handleBack = () => {
    props.history.push("/");
  };

  const searchBox = (
    <FlightSearchV2
      selectedDepartureDate={selectedDepartureDate}
      setSelectedDepartureDate={setSelectedDepartureDate}
      journeyType={journeyType}
      setJourneyType={setJourneyType}
      selectedArrivalDate={selectedArrivalDate}
      setSelectedArrivalDate={setSelectedArrivalDate}
      departureAirport={departureAirport}
      setDepartureAirport={setDepartureAirport}
      departureAirportName={departureAirportName}
      setDepartureAirportName={setDepartureAirportName}
      arrivalAirport={arrivalAirport}
      setArrivalAirport={setArrivalAirport}
      arrivalAirportName={arrivalAirportName}
      setArrivalAirportName={setArrivalAirportName}
      adults={adults}
      setAdults={setAdults}
      kids={kids}
      setKids={setKids}
      infants={infants}
      setInfants={setInfants}
      flightClass={flightClass}
      setFlightClass={setFlightClass}
      onSearchFlights={searchFlights}
    />
  );

  return (
    <>
      {/* Modern Green Banner with Centered Headline and Search Box */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap');
        .vendor-banner {
          background: #1eb5bf;
          padding: 56px 0 64px 0;
          text-align: center;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          backgroundImage: "url('${banner}')",
          backgroundSize: "auto",
          backgroundRepeat: "repeat",
        }
        .vendor-banner-headline {
          font-family: 'Montserrat', Arial, sans-serif;
          font-size: 2.2rem;
          font-weight: 900;
          color: #fff;
          margin-bottom: 18px;
          letter-spacing: 0.04em;
          min-height: 3em;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .typed-cursor {
          font-size: 2.2rem;
          color: #fff;
          animation: blink 0.7s infinite;
        }
        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0; }
          100% { opacity: 1; }
        }
        .typed-fade-out {
          opacity: 0;
          transition: opacity .25s;
        }
        .typed-cursor.typed-cursor--blink {
          animation: typedjsBlink 0.7s infinite;
          -webkit-animation: typedjsBlink 0.7s infinite;
          animation: typedjsBlink 0.7s infinite;
        }
        @keyframes typedjsBlink {
          50% { opacity: 0.0; }
        }
        @-webkit-keyframes typedjsBlink {
          0% { opacity: 1; }
          50% { opacity: 0.0; }
          100% { opacity: 1; }
        }
        .vendor-banner-searchbox {
          max-width: 900px;
          margin: 0 auto;
       
        
          padding: 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        @media (max-width: 600px) {
          .vendor-banner-headline { 
            font-size: 1.2rem;
            min-height: 2em;
          }
          .typed-cursor {
            font-size: 1.2rem;
          }
        }
      `}</style>
      <div
        className="vendor-banner"
        style={{
          background: "#1eb5bf",
          padding: "48px",
          textAlign: "center",
          position: "relative",
          // backgroundImage: "url('/img/bannerimage.png')"
          backgroundImage: `url(${banner})`,
          backgroundSize: "auto",
          backgroundRepeat: "repeat",
        }}
      >
        <div className="vendor-banner-headline">
          <span
            ref={typedRef}
            aria-label="Book Cheap Flights, Which You Can't Find Anywhere"
          />
        </div>
        <div className="vendor-banner-searchbox">{searchBox}</div>
      </div>
      {/* End Banner */}
      {/* <div style={{ paddingTop: "20px" }}> */}
      {/* Removed old image/banner */}
      {/* <div className={`container ${classes.flightBG}`}></div> */}
      {/* <div className="desktop">{searchBox}</div>
      </div> */}
      <div>
        <div className={`${classes.main}`} style={{ paddingTop: 0 }}>
          <div
            className={`container `}
            style={{ marginBottom: 40, padding: "0px" }}
          >
            {page == 2 && (
              <div style={{ marginTop: "40px" }}>
                {flights && flights.length > 0 ? (
                  <>
                    {console.log(
                      "DEBUG FlightResults - flights array:",
                      flights
                    )}
                    {console.log(
                      "DEBUG FlightResults - journeyType:",
                      journeyType
                    )}
                    {console.log(
                      "DEBUG FlightResults - flights length:",
                      flights.length
                    )}
                    {console.log(
                      "DEBUG FlightResults - first flight sample:",
                      flights[0]
                    )}
                    <DataTable
                      data={
                        loading || !flights || flights.length == 0
                          ? []
                          : flights
                      }
                      journeyType={journeyType}
                      onFlightSelected={handleFlightSelect}
                      vendorCommission={{
                        type: props.commissionType,
                        value: props.commissionValue,
                      }}
                      adminCommission={{
                        type: props.adminCommissionType,
                        value: props.adminCommissionValue,
                      }}
                      currency={props.currency}
                      graphComponent={
                        <div
                          className="filter-box"
                          style={{ minWidth: "100px" }}
                        >
                          <PriceGraph
                            query={searchQuery}
                            selectedDate={selectedDepartureDate}
                          />
                        </div>
                      }
                    />
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        padding: "10px 0px",
                        borderRadius: "5px",
                        backgroundColor: "var(--white)",
                        marginTop: "15px",
                      }}
                    >
                      <Typography
                        component="p"
                        style={{ textAlign: "center", color: "var(--darker)" }}
                      >
                        No Flights Found
                      </Typography>
                    </div>
                  </>
                )}
              </div>
            )}
            <RecentSearches onSelect={onRecentSearchSelect} />
            {page == 1 && (
              <>
                <PopularDestinations
                  onSelect={handlePopularDestinationSelect}
                />
              </>
            )}
            <div className="btnGO" onClick={toggleDrawer(true)}>
              {" "}
              <a
                style={{
                  border: "1px solid #fff",
                  borderRadius: "50%",
                  padding: "10px 10px",
                }}
              >
                <Typography
                  component="p"
                  style={{ textAlign: "center", color: "var(--white)" }}
                >
                  GO
                </Typography>
              </a>
            </div>
            <div>
              <SwipeableDrawer
                anchor={"bottom"}
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
              >
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "var(--dark)",
                    borderRadius: "30px 30px 0px 0px",
                    height: "330px",
                  }}
                  role="presentation"
                >
                  <div className="mobile">{searchBox}</div>
                </Box>
              </SwipeableDrawer>
            </div>
          </div>
        </div>
      </div>
      <Loader show={loading} />
    </>
  );
}

const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
  }
  let adminCommissionType = "Fixed";
  let adminCommissionValue = 0;
  if (
    state.admin &&
    state.admin.commission &&
    state.admin.commission.commissionType
  ) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    searches: state.searchHistory.searches,
    currency: state.flight.currency ? state.flight.currency : "",
    commissionValue: commissionValue,
    commissionType: commissionType,
    adminCommissionValue: adminCommissionValue,
    adminCommissionType: adminCommissionType,
  };
};

export default React.memo(connect(mapStateWithProps)(Airports));
